angular.module('lf.common')

.directive('cardExpiration', function () {
  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, model) {
      scope.$watch('[data.expMonth, data.expYear]', function (value) {
        if (value.length === 2 && value[0] && value[1]) {
          var selectedMonth = parseInt(value[0].value)-1;
          var selectedYear = parseInt(value[1].value);
          console.log(((selectedYear > scope.currentYear) || (selectedYear == scope.currentYear && selectedMonth >= scope.currentMonth)));

          model.$setValidity('invalidExpirationDate', ((selectedYear > scope.currentYear) || (selectedYear == scope.currentYear && selectedMonth >= scope.currentMonth)));
        }
        return value;
      }, true);
    }
  }
});
